import classNames from 'classnames/bind';
import styles from './BasicCard.module.scss';
import { Card } from '@/components';
import CardSideFront from '../CardSideFront/CardSideFront';

let cx = classNames.bind(styles);

export default function BasicCard({ cardAttr, attributes, innerBlocks, style }) {
	const className = attributes.className?.split(' ') || [];

	return (
		<Card id={attributes.anchor} className={cx(['basic-card', ...className, cardAttr.reverseTextColor && 'is-dark'])} background={cardAttr.backgroundColor && `bg-${cardAttr.backgroundColor[0]}`} style={style} fullHeight={attributes.fullHeight} outline={cardAttr.hasBorder}>
			<CardSideFront cardAttr={cardAttr} innerBlocks={innerBlocks} />
		</Card>
	);
}
